import * as React from "react"

import {Box} from "@mui/material";

import { ActionButton, AppTableSeeker } from "@components";
import { CreateReportButton } from "./actions"
import { eanColumn, brandColumn, discountColumn, pvrColumn, pvpColumn, productColumn, priceCompetitorColumn, diffCompetitorColumn } from "./columns"
import {TABS_OFFERS} from "../../@constants";
import CustomDashboardsPrimorFlashOffersErrorPage from "../../errorPage";
import {flashOffersError} from "../../@signals";



export default function CustomDashboardsPrimorFlashOffersOffersTable({ title, data, tabID, handleChangeReloadData, onDownload }) {

	if (!data?.length && title === TABS_OFFERS.PRIMOR && !flashOffersError.value)
		return <CustomDashboardsPrimorFlashOffersErrorPage errorCode={'PRIMOR_OFFERS_ERROR'} />

	if (!data?.length )
		return <></>

    return <AppTableSeeker
		data={data}
		columns={[
			eanColumn(),
			brandColumn(),
			productColumn(),
			pvrColumn(),
			pvpColumn(),
			discountColumn(),
			priceCompetitorColumn(title),
			diffCompetitorColumn(title)
		]}
		options={{
			onDownload: onDownload,
			customToolbar: () => <Box display="flex" gap={3}>
				{title === TABS_OFFERS.DRUNI && <ActionButton
					label="Update Data"
					icon="rotate-reverse"
					onClick={handleChangeReloadData}
				/>}
				<CreateReportButton />
			</Box>
		}}
	/>
}